/* --- colors ------------------------------------------------- */

/* --- Pro endorsements (names + images come from shared PRO_PLAYERS) --- */

import { PRO_PLAYERS } from '@/components/trial/shared/pro-players';

export const DARK_BG = '#080809';
export const NOPING_GREEN = '#93FF18';
export const EVIL_RED = '#2ECDFF';
export const ACCENT_BLUE = '#2ECDFF';
export const TEXT_LIGHT = '#E5E7EB';
export const MUTED_GRAY = '#929298';

/* --- animation easing --------------------------------------- */

export const EASE_OUT: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];
export const EASE_EXPO: [number, number, number, number] = [0.16, 1, 0.3, 1];

/* --- Noping stats (inlined from @/lib/constants) ------------ */

export const NOPING_STATS = {
  servers: '2,000+',
  countries: '150+',
  gamesSupported: '3,000+',
} as const;

export const PRO_ENDORSEMENTS = [{ ...PRO_PLAYERS.sacy }, { ...PRO_PLAYERS.gaules }, { ...PRO_PLAYERS.coldzera }] as const;

/* --- Weapon stats ------------------------------------------- */

export const WEAPON_STATS = [
  { value: 80, suffix: '%', label: 'PING REDUCTION', color: NOPING_GREEN, icon: 'zap' },
  { value: 2000, suffix: '+', label: 'GLOBAL SERVERS', color: ACCENT_BLUE, icon: 'globe' },
  { value: 150, suffix: '+', label: 'COUNTRIES', color: NOPING_GREEN, icon: 'shield' },
  { value: 3, suffix: 'M+', label: 'ACTIVE GAMERS', color: ACCENT_BLUE, icon: 'crosshair' },
] as const;

/* --- Arsenal tool cards ------------------------------------- */

export const TOOL_CARDS = [
  { icon: 'zap', name: 'FPS Boost', stat: '+110%', desc: 'Squeeze up to 110% more frames. Optimizes CPU/RAM allocation for raw performance.', color: NOPING_GREEN },
  { icon: 'crosshair', name: 'Aim Trainer', stat: 'Built-in', desc: 'Sharpen your reflexes without leaving the app. Train aim between queues.', color: ACCENT_BLUE },
  { icon: 'headphones', name: 'AudioPad', stat: '360\u00B0', desc: 'Enhanced audio positioning. Hear every footstep, every ability, crystal clear.', color: NOPING_GREEN },
  { icon: 'play-circle', name: 'Replay X', stat: 'Record', desc: 'Record and review gameplay. Find your mistakes. Improve faster.', color: ACCENT_BLUE },
  { icon: 'settings', name: 'Pro Settings', stat: '1-Click', desc: 'Import pro player configurations for your favorite games instantly.', color: NOPING_GREEN },
  { icon: 'wifi', name: 'Multi Internet', stat: 'Max', desc: 'Combine multiple connections for maximum stability and zero drops.', color: ACCENT_BLUE },
] as const;

/* --- Before / After data ------------------------------------ */

export const BEFORE_AFTER = {
  before: [
    { metric: 'PING', value: '180ms', bar: 90, detail: 'Rubber-banding every fight' },
    { metric: 'PACKET LOSS', value: '12%', bar: 75, detail: 'Constant micro-stutters' },
    { metric: 'FPS DROPS', value: '40%', bar: 65, detail: 'Freezes at worst moments' },
    { metric: 'ROUTE', value: '15 HOPS', bar: 80, detail: 'Bouncing through 3 continents' },
  ],
  after: [
    { metric: 'PING', value: '12ms', bar: 8, detail: 'Instant hit registration' },
    { metric: 'PACKET LOSS', value: '0%', bar: 2, detail: 'Zero. None. Gone.' },
    { metric: 'FPS DROPS', value: '0%', bar: 2, detail: 'Locked and smooth' },
    { metric: 'ROUTE', value: '3 HOPS', bar: 15, detail: 'Direct optimized path' },
  ],
} as const;

/* --- Kill steps --------------------------------------------- */

export const KILL_STEPS = [
  { num: '01', title: 'DOWNLOAD', desc: '30 seconds. One file. One click. Done. No bloatware, no BS.', accent: NOPING_GREEN },
  { num: '02', title: 'SELECT GAME', desc: 'Pick your game. We auto-detect the fastest route to your server.', accent: ACCENT_BLUE },
  { num: '03', title: 'DOMINATE', desc: 'Zero lag. Zero excuses. Pure, unfiltered performance. Go win.', accent: NOPING_GREEN },
] as const;

/* --- FAQ data ----------------------------------------------- */

export const FAQ_ITEMS = [
  { q: 'WHAT IS NOPING?', a: 'NoPing is a gaming network optimizer trusted by 3M+ players worldwide. It uses AI-powered route optimization to find the fastest path between you and game servers, plus includes FPS Boost to squeeze maximum performance from your hardware.' },
  { q: 'HOW DOES THE FREE TRIAL WORK?', a: 'Create an account, get 1 full day of premium access to every feature, every server, every game. No credit card needed. No strings attached.' },
  { q: 'WILL NOPING GET ME BANNED?', a: 'No. NoPing only optimizes your network route. It does not modify game files, inject code, or interact with game memory. It is completely safe and compliant with all game terms of service.' },
  { q: "WHAT IF IT DOESN'T WORK FOR ME?", a: 'NoPing works across 3,000+ games and 150+ countries. If it does not improve your connection, you lose nothing \u2014 the trial is completely free. No risk, all reward.' },
  { q: 'DOES IT WORK WITH MY ISP?', a: "Yes. NoPing works with every ISP in every country. It creates an optimized tunnel that bypasses your ISP's inefficient routing. The worse your ISP routing, the bigger the improvement." },
] as const;

/* --- Game carousel data ------------------------------------- */

export const V2A_GAMES = [
  { name: 'Valorant', src: '/images/Valorant.webp' },
  { name: 'CS2', src: '/images/CS2.webp' },
  { name: 'Fortnite', src: '/images/Fortnite.webp' },
  { name: 'Dota 2', src: '/images/Dota2.webp' },
  { name: 'World of Warcraft', src: '/images/World of Warcraft.webp' },
  { name: 'Final Fantasy XIV', src: '/images/Final Fantasy XIV.webp' },
  { name: 'Ragnarok', src: '/images/Ragnarok.webp' },
  { name: 'StarCraft', src: '/images/StarCraft.webp' },
] as const;
